import { render, staticRenderFns } from "./MatchScoreModalTemplate.vue?vue&type=template&id=20d7bf5a&scoped=true&"
import script from "./MatchScoreModalTemplate.vue?vue&type=script&lang=js&"
export * from "./MatchScoreModalTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d7bf5a",
  null
  
)

export default component.exports